// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#about[data-v-17f4aaaa]{background-color:#f4f7f5}", ""]);
// Exports
module.exports = exports;
